import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { AuthenticationWrap } from './overview/style';
import logo from '../../../static/img/tripago-logo-1.jpeg';
import LanguageDropdown from '../../../components/Language-Dropdown/LanguageDropdown';
// import logo from '../../../static/img/tripago-logo-1.jpeg';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <AuthenticationWrap style={{ backgroundImage: `url("${require('../../../static/img/admin-bg-light.png')}")` }}>
          <div className="droppdown-auth">
            <LanguageDropdown />
          </div>
          <div className="ninjadash-authentication-wrap">
            <div className="ninjadash-authentication-brand">
              <Link to="/">
                <img src={logo} alt="" style={{ width: '100%', height: '100%' }} />
              </Link>
            </div>
            <WraperContent />
          </div>
        </AuthenticationWrap>
      </Suspense>
    );
  };
};

export default AuthLayout;
